import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

// Falls back to build-time env for dev/test; in prod the backend sets user.product per user.
const BUILD_PRODUCT = process.env.REACT_APP_PRODUCT || "stroke";

export default function ProductRoute({ allowedProducts, children }) {
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);

  // Use the per-user product from the login response if available, otherwise build-time fallback
  const product = user?.product || BUILD_PRODUCT;

  if (!allowedProducts || allowedProducts.includes(product)) {
    return children;
  }

  return <Navigate to="/unauthorized" state={{ from: location }} replace />;
}
